import React, { ReactNode, useState, FC } from 'react';
import {
  ActiveDocNodeContext,
  CurrentFolderContext,
  INavFolder,
  NavFoldersContext,
  ROOT_FOLDER,
  UpdateActiveDocNodeContext,
  UpdateCurrentFolderContext,
  UpdateNavFoldersContext
} from './context';

export const DocumentLibraryProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [activeDocNode, setActiveDocNode] = useState<string | null>(null);
  const [navFolders, setNavFolders] = useState<INavFolder[]>([ROOT_FOLDER]);
  const [currentFolder, setCurrentFolder] = useState<INavFolder>(ROOT_FOLDER);
  return (
    <UpdateActiveDocNodeContext.Provider value={setActiveDocNode}>
      <ActiveDocNodeContext.Provider value={activeDocNode}>
        <UpdateCurrentFolderContext.Provider value={setCurrentFolder}>
          <UpdateNavFoldersContext.Provider value={setNavFolders}>
            <CurrentFolderContext.Provider value={currentFolder}>
              <NavFoldersContext.Provider value={navFolders}>{children}</NavFoldersContext.Provider>
            </CurrentFolderContext.Provider>
          </UpdateNavFoldersContext.Provider>
        </UpdateCurrentFolderContext.Provider>
      </ActiveDocNodeContext.Provider>
    </UpdateActiveDocNodeContext.Provider>
  );
};
